import { useState, useEffect, type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import type { AuthUser } from "../lib/api";
import { api } from "../lib/api";
import logoUrl from "../assets/sibit-logo.jpg";
import { UpdateBanner } from "./UpdateBanner";

export function AppShell(props: { user: AuthUser; onLogout: () => void; children: ReactNode }) {
  const loc = useLocation();
  const isInbox = loc.pathname.startsWith("/inbox");
  const isKanban = loc.pathname.startsWith("/kanban") || loc.pathname.startsWith("/board") || loc.pathname.startsWith("/timesheets");
  const isLabs = loc.pathname.startsWith("/labs") || loc.pathname.startsWith("/werkstatt");
  const isSettings = loc.pathname.startsWith("/settings");
  const isDocs = loc.pathname.startsWith("/documentation");
  const isAuswertung = loc.pathname.startsWith("/auswertung");
  const isTestProto = loc.pathname.startsWith("/admin/test-protocols");
  // 'developer' erbt alle admin-Rechte (Migration 033). isAdmin → für Admin-
  // Nav-Items, isDeveloper → für Werkstatt-Zugriff (admin alleine reicht NICHT).
  const isAdmin = props.user.role === "admin" || props.user.role === "developer";
  const isDeveloper = props.user.role === "developer";
  const [version, setVersion] = useState("");
  const [builtAt, setBuiltAt] = useState("");
  useEffect(() => { api.system.version().then((v) => { setVersion(v.version); setBuiltAt(v.builtAt || ""); }).catch(() => {}); }, []);

  return (
    <div className="shell">
      <header className="shell-header">
        <div className="shell-brand">
          <img src={logoUrl} alt="Sibit" className="shell-logo" />
        </div>
        <nav className="shell-nav">
          {/* Inbox developer-only (2026-06-09): Triage-Inbox ist nicht fertig —
              vor der Kunden-Abnahme für user/admin ausgeblendet (Route in
              App.tsx leitet zusätzlich auf /board um). */}
          {isDeveloper && (
            <Link to="/inbox" className={isInbox ? "active" : ""}>Inbox</Link>
          )}
          <Link to="/board" className={isKanban ? "active" : ""}>Kanban</Link>
          <Link to="/auswertung" className={isAuswertung ? "active" : ""}>Auswertung</Link>
          {isDeveloper && (
            <Link to="/werkstatt/abrechnung/upload" data-perm="werkstatt-route" className={isLabs ? "active" : ""}
                  title="Pipeline-Werkstatt: Glass-Box-Doku + Dev-Environment. Developer-only.">
              Pipeline-Werkstatt
            </Link>
          )}
          <Link to="/settings" className={isSettings ? "active" : ""}>Einstellungen</Link>
          <Link to="/documentation" className={isDocs ? "active" : ""}>Dokumentation</Link>
          {isAdmin && (
            <Link to="/admin/test-protocols" data-perm="test-protocols-nav" className={isTestProto ? "active" : ""}>Test-Protokoll</Link>
          )}
        </nav>
        <div className="shell-user">
          <span>{props.user.displayName}</span>
          <button type="button" className="link" onClick={props.onLogout}>Abmelden</button>
        </div>
      </header>
      {isAdmin && <UpdateBanner />}
      <main className="shell-main">{props.children}</main>
      <footer style={{ padding: "6px 16px", fontSize: 11, color: "#94a3b8", textAlign: "right" }}>
        Sibit Personalverrechnung{version ? ` · Version ${version}` : ""}{builtAt ? ` (Stand ${new Date(builtAt).toLocaleDateString("de-AT")})` : ""}
      </footer>
    </div>
  );
}
